import { ChangeDetectorRef, Component, OnInit, EventEmitter, Output, Input, OnChanges, ElementRef, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CfetBaseComponent, CfetService, CFETILMEndpointsConstant, UrlUtil, CfetPageNamesConstant } from '../../../cfet-core';
import { environment } from './../../../../environments/environment';

// Temporarily Added to show hard coded data
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
    selector: 'app-customer-eligibility-utf-workplace',
    templateUrl: './customer-eligibility-utf-workplace.component.html',
    styleUrls: ['./customer-eligibility-utf-workplace.component.scss'],
    standalone: false
})
export class CustomerEligibilityUtfWorkplaceComponent extends CfetBaseComponent implements OnInit, OnChanges {

  customerEligibilityWorkplaceFormGroup: UntypedFormGroup;
  stateValue: UntypedFormControl;
  zipCode: UntypedFormControl;
  searchValue: UntypedFormControl;
  disabledContinueButton = true;
  stateValueOption: any;
  stateList: any[] = [];
  selectedState: any;
  selectedZip: any;
  previousSearchValue: any;
  zipcodeError: boolean;
  showStateZipSection = true;
  showSelectedStateZip = false;
  showDontSeeWorkplaceManually = false;
  showSearchSection = false;
  displaySearchResult = false;
  showSelectedSearchedResult = false;
  noResultsFound = false;
  showEligibilityCompletion = false;
  selectedName: any;
  selectedAddress: any;
  selectedCity: any;
  selectedStateInWorkplace: any = '';
  selectedZipInWorkplace: any;
  checkState = '';
  workplaceList: any = [];
  searchResult: any;
  searchResultsFullData: any;
  searchedData: any = [];
  searchResultsCriteria: { entityName: string; };
  checkstateAndZip = { 'state': '', 'zipcode': '' };
  dropdowndefaultValue = true;
  getorgProfileInfo: any;
  showLoading = false;
  stateData: Array<any> = [];
  spaTerritories: Array<any> = [];
  url = '';
  disableSearchPageContinueButton = true;
  orgInfoDetails: any;
  profileData: any;
  nonSpaAffCode = true;
  initialState: string;
  initialZip: string;
  userType: string;
  hasChanges: boolean = false;
  territoryStates: any = [];
  showAffCodeSection: boolean = false;
  affiliationCodeList: any[] = [];
  affiliationCodeValueOption: any;
  disableAffContinue = true;
  affiliatedOrgId: string;
  affiliationCode: any;
  checkAffCode = '';
  hideButtons: boolean = true;
  OrgDetails: any = {};
  isSpaOrg: boolean;
  showVerifySection = false;

  @Input() showWorkplaceSection: boolean;
  @Input() showtickicon: boolean;
  @Input() stateAndZip: any;
  @Input() manuallyEnteredValues: any;
 // @Input() userType: string;
  @Input() selectedCategory: any;
  @Input() selectedRole: any;
  @Input() selectedconfirmValue: any;
  @Output() eligibilitycompletionstatus = new EventEmitter<any>();
  @Output() editSelected = new EventEmitter<any>();
  @Output() workplaceSelected = new EventEmitter<any>();
  @Output() stateAndZipPresent = new EventEmitter<any>();
  @Output() showLoadingSpinner = new EventEmitter<any>();
  @Output() manuallyAddedValues = new EventEmitter<any>();
  @Output() savedManualValues = new EventEmitter<any>();
  @Output() showCancelModal = new EventEmitter<any>();
  @Output() goToQAndA = new EventEmitter<any>();

  constructor(
    private cfetService: CfetService,
    // Temporarily added for hard coded data
    private http: HttpClient,
    private router: Router,
    private elementRef: ElementRef,
    private urlUtil: UrlUtil,
    private cd: ChangeDetectorRef) {
    super();
  }

  private setLoading(loading: boolean): void {
    this.showLoading = loading;
    this.showLoadingSpinner.emit(loading);
    this.cd.detectChanges();
  }

  ngOnChanges() {

    if (!this.stateAndZip) {
      this.stateAndZip = {};
    }

    if (this.showWorkplaceSection === false) {
      this.showStateZipSection = false;
      this.showSelectedStateZip = false;
      this.showSearchSection = false;
      this.showDontSeeWorkplaceManually = false;
      this.showEligibilityCompletion = true;

      this.eligibilitycompletionstatus.emit({
        completionStatus: this.showtickicon
      });
    }

    // ✅ SAFE ORG DATA CHECK
    if (this.stateAndZip && typeof this.stateAndZip === 'object' && this.stateAndZip.org_name) {

      this.selectedName = this.stateAndZip.org_name;
      this.selectedAddress = this.stateAndZip.address;
      this.selectedCity = this.stateAndZip.city;

      if (this.stateAndZip.state && this.stateAndZip.zipcode) {
        this.selectedStateInWorkplace = this.stateAndZip.state;
        this.selectedZipInWorkplace = this.stateAndZip.zipcode;
      }

    }
    // ✅ SAFE MANUAL ENTRY CHECK
    if (this.manuallyEnteredValues && this.manuallyEnteredValues.org_name) {
      this.selectedName = this.manuallyEnteredValues.org_name;
      this.selectedAddress = this.manuallyEnteredValues.address;
      this.selectedCity = this.manuallyEnteredValues.city;
      this.selectedStateInWorkplace = this.manuallyEnteredValues.state;
      this.selectedZipInWorkplace = this.manuallyEnteredValues.zipcode;
      this.checkstateAndZip['org_name'] = this.manuallyEnteredValues.org_name;
      this.checkstateAndZip['address'] = this.manuallyEnteredValues.address;
      this.checkstateAndZip['city'] = this.manuallyEnteredValues.city;
      this.checkstateAndZip['state'] = this.manuallyEnteredValues.state;
      this.checkstateAndZip['zipcode'] = this.manuallyEnteredValues.zipcode;
    }
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.stateValue = new UntypedFormControl('', [Validators.required]);
    this.zipCode = new UntypedFormControl('', { validators: [Validators.required, Validators.minLength(5)], updateOn: 'change' });
    this.searchValue = new UntypedFormControl('', [Validators.required]);
    this.customerEligibilityWorkplaceFormGroup = new UntypedFormGroup({
      stateValue: this.stateValue,
      zipCode: this.zipCode,
      searchValue: this.searchValue
    });
    this.affiliationCodeList = [{ 'value': 'Select', 'text': 'Select' }];
    this.affiliationCodeValueOption = { 'value': 'Select', 'text': 'Select' };
    if (sessionStorage.getItem('eligibilty-signup') && Object.keys(sessionStorage.getItem('eligibilty-signup')).length !== 0) {
      this.showEligibilityCompletion = true;
      this.showStateZipSection = false;
      this.showSelectedStateZip = false;
      this.showEligibilityCompletion = true;
    }
    this.stateValueOption = { 'value': 'Select', 'text': 'Select' };
    this.stateList = [];
    const commonListValuesRaw = sessionStorage.getItem('ngStorage-commonListValues');
    const commonListValues = commonListValuesRaw ? JSON.parse(commonListValuesRaw) : null;
    this.stateData = commonListValues?.validStates || [];
    this.spaTerritories = commonListValues?.validSPATerritories || {};
    Object.keys(this.spaTerritories).forEach((key) => {
      let val = this.spaTerritories[key];
      this.stateData = this.stateData.concat(val);
      this.territoryStates = this.territoryStates.concat(val);
    });
    this.stateData.sort();
    if (this.stateData && this.stateData.length > 0) {
      this.stateList = this.stateData.map(
        stateValue => {
          return { value: stateValue, text: stateValue.split(':')[1] };
        }
      );
    }
    if (this.stateAndZip !== undefined && this.stateAndZip !== '' && this.stateAndZip.selectedState &&
      this.stateAndZip.selectedState !== undefined && this.stateAndZip.selectedState !== '') {
      this.selectedState = this.stateAndZip.selectedState;
      this.selectedZip = this.stateAndZip.selectedZip;
    }
    if (this.stateAndZip !== undefined && this.stateAndZip !== '' && this.stateAndZip.searchedResult &&
      this.stateAndZip.searchedResult !== undefined && this.stateAndZip.searchedResult !== '') {
      this.searchResultsFullData = this.stateAndZip.searchedResult;
    }
    if (sessionStorage.getItem('orgInfo') && Object.keys(sessionStorage.getItem('orgInfo')).length !== 0) {
      this.orgInfoDetails = JSON.parse(sessionStorage.getItem('orgInfo'));
      if (this.orgInfoDetails['isSpaOrg'] === '' || this.orgInfoDetails['isSpaOrg'] === undefined ||
        this.orgInfoDetails['isSpaOrg'] === false) {
        this.nonSpaAffCode = false;
      } else {
        this.nonSpaAffCode = true;
      }
    }
    if (this.affiliationCode && this.affiliationCode !== '' && this.affiliationCode !== 'Select') {
      this.nonSpaAffCode = true;
    }
    this.initialState = this.stateValue.value;
    this.initialZip = this.zipCode.value.replace(/[^0-9\-]/g, '');
    if (this.selectedName) {
      this.showSelectedSearchedResult = true;
      this.stateValueOption = { 'value': this.selectedStateInWorkplace, 'text': this.selectedStateInWorkplace.split(':')[1] };
      this.customerEligibilityWorkplaceFormGroup.get('stateValue').setValue(this.selectedStateInWorkplace, { emitEvent: true });
      this.customerEligibilityWorkplaceFormGroup.get('zipCode').setValue(this.selectedZipInWorkplace);
      this.fetchOrganizationDetails();
    } else {
      this.showSelectedSearchedResult = false;
    }
    this.checkButtonState();  // Check button state on page load
    this.onValueChanges();
  }

  onValueChanges() {
    this.customerEligibilityWorkplaceFormGroup.valueChanges.subscribe(val => {
      // Track if changes have been made to state or zip
      const currentState = val.stateValue !== '' && val.stateValue !== 'Select';
      const currentZip = val.zipCode.replace(/[^0-9]/g, '').length === 5; // Ensure zip is exactly 5 digits
      // Check if values have changed from initial
      const stateChanged = this.initialState !== val.stateValue;
      const zipChanged = this.initialZip !== val.zipCode.replace(/[^0-9\-]/g, '');
      this.hasChanges = stateChanged || zipChanged; // Update hasChanges state
      // Enable the button only if changes have occurred
      this.disabledContinueButton = !(this.hasChanges && currentState && currentZip);
    });
  }

  checkButtonState() {
    const currentState = this.initialState !== '' && this.initialState !== 'Select';
    const currentZip = this.initialZip.replace(/[^0-9]/g, '').length === 5; // Ensure zip is 5 digits
    this.disabledContinueButton = !(this.hasChanges && currentState && currentZip);
  }
  // Method to reset initial values when the state or zip changes
  resetInitialValues() {
    this.initialState = this.stateValue.value;
    this.initialZip = this.zipCode.value.replace(/[^0-9\-]/g, '');
    this.showSelectedSearchedResult = false;
    this.selectedStateInWorkplace = '';
    this.selectedName = '';
    this.displaySearchResult = false;
  }

  onChangeState(event) {
    this.checkState = '';
    this.stateValue.setValue(event.value);
    if (this.stateValue.value !== 'select') {
      this.dropdowndefaultValue = false;
      if (screen.width > 1024) {
        const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state');
        inputelem1.setAttribute('style', 'color : #333 !important');
      } else {
        const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state').nextElementSibling;
        inputelem1.setAttribute('style', 'color : #333 !important');
      }
    } else {
      this.dropdowndefaultValue = true;
      const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state');
      inputelem1.setAttribute('style', 'color : #868585 !important');
    }
    this.resetInitialValues();
    this.showSelectedSearchedResult = false;
    this.showSearchSection = false;
    this.showAffCodeSection = false;
    this.showDontSeeWorkplaceManually = false;
    if (this.searchValue.value) {
      this.searchValue.setValue('');
      this.disabledContinueButton = false;
      this.displaySearchResult = false;
      this.disableSearchPageContinueButton = true;
    }
    this.onValueChanges();

  }

  onClickState(event) {
    if (event.target.ariaExpanded === 'true') {
      this.checkState = 'dropdown-opened';
    } else {
      this.checkState = '';
    }
  }

  onClickAffiliation(event) {
    if (event.target.ariaExpanded === 'true') {
      this.checkAffCode = 'dropdown-opened';
    } else {
      this.checkAffCode = '';
    }
  }

  @HostListener('document:click', ['$event']) clickout(event) {
    if (event.target.id !== 'select_state') {
      this.checkState = '';
    }
  }

  changeZip() {
    this.resetInitialValues();
    this.checkButtonState();     // Re-check button state
    this.onValueChanges();
    this.showSearchSection = false;
    this.showAffCodeSection = false;
    this.showDontSeeWorkplaceManually = false;
    if (this.searchValue.value) {
      this.searchValue.setValue('');
      this.displaySearchResult = false;
      this.disableSearchPageContinueButton = true;
    }
    this.checkZip();
  }

  checkZip() {
    this.zipcodeError = this.zipCode.value.replace(/[^0-9\-]/g, '').length < 5 ? true : false;
  }

  fetchOrganizationDetails() {
    this.selectedState = this.stateValue.value.split(':')[1] ? this.stateValue.value.split(':')[1] : this.stateValue.value.split(':')[0];
    this.selectedZip = this.zipCode.value.replace(/[^0-9\-]/g, '');
    this.zipCode.setValue(this.zipCode.value.replace(/[^0-9\-]/g, ''));
    this.checkstateAndZip = { 'state': this.stateValue.value, 'zipcode': this.zipCode.value.replace(/[^0-9\-]/g, '') };
    this.disabledContinueButton = true;
    this.searchedData = [];
    this.workplaceList = [];
    this.disableSearchPageContinueButton = true;
    const requestParam = {
      "search_criteria": [
        {
          'attribute_name': 'state',
          'attribute_value': this.checkstateAndZip.state
        }, {
          'attribute_name': 'zipcode',
          'attribute_value': this.checkstateAndZip.zipcode
        }]
    };
    // window.scrollTo(0, 0);
    this.setSearchList([]);
    this.setLoading(true);
      this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.SEARCH_DETAILS).subscribe((data: any) => {
        this.setSearchList(data);
      }, (_error) => {
        this.setSearchList([]);
        this.setLoading(false);
      });
    const zipCodeControl = this.customerEligibilityWorkplaceFormGroup.get('zipCode');
    if (zipCodeControl?.valid && this.stateValueOption) {
      this.showSearchSection = true;
      this.hideButtons = false;
      this.disableSearchPageContinueButton = true;
    }
    // this.stateAndZipPresent.emit(this.checkstateAndZip);
    this.noResultsFound = false;
  }

  continue(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showStateZipSection = false;
      this.showSelectedStateZip = true;
      this.showSearchSection = true;
      this.stateAndZipPresent.emit(this.checkstateAndZip);
    }
  }

  setSearchList(data) {
    if (data && data.length > 0) {
      this.setLoading(false);
      this.searchResult = [];
      for (const element of data) {
        let tempSearchList = { 'org_name': '', 'zipcode': '', 'address': '', 'city': '', 'state': '', 'orgid': '' };
        tempSearchList.org_name = element.org_name;
        tempSearchList.orgid = element.orgid;
        this.profileData = element.profile;
        tempSearchList = this.setTempSearchList(tempSearchList);
        this.searchResult.push(tempSearchList);
      }
      this.searchResultsFullData = this.searchResult;
      this.checkstateAndZip['searchedResult'] = this.searchResult;
      this.checkstateAndZip['selectedState'] = this.stateValue.value;
      this.checkstateAndZip['selectedZip'] = this.zipCode.value.replace(/[^0-9\-]/g, '');
    } else {
      this.searchResult = [];
      this.searchResultsFullData = [];
      this.setLoading(false);
    }
  }

  getOrgProfileDetails() {
    console.log('method called');
    this.setLoading(true);
    const param = {
      'xorgid': this.affiliatedOrgId
    };
    console.log('ORG ID:', this.affiliatedOrgId);
    const url = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.GET_ORG_PROFILE, param)}`;
    console.log('URL:', url);
    this.userType = sessionStorage.getItem('userType');
    this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {
      sessionStorage.setItem('oraInformation', JSON.stringify(this.getOraInformation(data)));
      const fanList = data.fan || data.FAN;
      this.affiliationCodeList = Array.isArray(fanList) ?
        fanList.filter(f =>
          f.retCode &&
          f.types?.some(type =>
            type.replace('Subscriber Paid', '').trim() === this.userType
          )
        )
          .map(f => ({
            value: f.retCode,
            text: f.retCode
          })) : [];
          console.log('AFF List:', this.affiliationCodeList);
      this.affiliationCodeValueOption = { 'value': 'Select', 'text': 'Select' };
      this.affiliationCode = 'Select';
      if (this.affiliationCodeList &&this.affiliationCodeList.length > 0) {
        this.showAffCodeSection = true;
        console.log('show aff true');
        console.log('Aff list', this.affiliationCodeList);
        console.log('show Aff',this.showAffCodeSection);
        this.hideButtons = true;
      }
      else {
        this.hideButtons = false;
        this.showAffCodeSection = false;
        console.log('show aff false');

        this.disableSearchPageContinueButton = false;
      }
      this.setLoading(false);
    },
      (error) => {
        console.log('Error fetching organization profile details:', error);
        this.showAffCodeSection = false;
        this.affiliationCodeList = [];
        this.disableSearchPageContinueButton = false;
        this.setLoading(false);
        this.hideButtons = false
      });
  }

  setTempSearchList(tempSearchList): any {
    this.profileData.forEach(val => {
      if (val.attribute_name === 'Address 1') {
        tempSearchList.address = val.attribute_value;
      }
      if (val.attribute_name === 'city') {
        tempSearchList.city = val.attribute_value;
      }
      if (val.attribute_name === 'zipcode') {
        tempSearchList.zipcode = val.attribute_value;
      }
      if (val.attribute_name === 'state') {
        tempSearchList.state = val.attribute_value;
      }
    });
    return tempSearchList;
  }

  cancelApplication(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }
  editStateZip(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      sessionStorage.removeItem('verificationType');
sessionStorage.setItem('RETURN_FLOW', 'ELIGIBILITY');
      this.redirecturl(this.cfetNavLinks.utf_header_links.check_eligibility_link);
    }
  }
  redirecturl(url) {
    window.location.href = url;
  }
  filterEntitywithSearchText(Entites, searchText, flag): any[] {
    const filteredData = [];
    if (Entites && Entites.length > 0) {
      Entites.forEach((entity) => {
        if (entity.org_name.toLowerCase().indexOf(searchText.entityName.toLowerCase()) !== -1) {
          filteredData.push(entity);
        }
      });
    }
    return filteredData;
  }

  searchWorkplace() {
    this.disableSearchPageContinueButton = true;
    this.showSelectedSearchedResult = false; // Ensure it's false before searching
    if (this.searchValue.value.length >= 3) {
      // Hide the selected one and disable continue
      this.disableSearchPageContinueButton = true;
      this.searchResultsCriteria = { 'entityName': this.searchValue.value };
      this.searchedData = this.filterEntitywithSearchText(this.searchResultsFullData, this.searchResultsCriteria, false);
      if (this.searchedData.length > 0) {
        this.displaySearchResult = true;
        this.noResultsFound = false;
        this.workplaceList = [];
        this.workplaceList = this.workplaceList.concat(this.searchedData);
        this.showSelectedSearchedResult = false;
      } else {
        this.displaySearchResult = false;
        this.noResultsFound = true;
      }
    } else {
      this.displaySearchResult = false;
      this.noResultsFound = false;
    }
  }

  addManually(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showSearchSection = true;
      this.showSelectedStateZip = false;
      this.displaySearchResult = false;
      this.showDontSeeWorkplaceManually = true;
      this.showSelectedSearchedResult = false;
      this.showAffCodeSection = false;
      this.searchValue.setValue('');
    }
  }

  // eligibility completion page section
  editWorkplace(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      // if (this.stateAndZip.isPSEAffliationcode) {
      //   this.editStateZip(event);
      //   this.showSelectedStateZip = false;
      //   this.showSearchSection = false;
      //   this.showEligibilityCompletion = false;
      //   this.showDontSeeWorkplaceManually = false;
      //   this.zipCode.setValue('');
      //   this.stateValueOption = { 'value': 'Select', 'text': 'Select' };
      // } else{

      this.showEligibilityCompletion = false;
      // this.selectedAddress =  true;
      // this.selectedCity=true;
      // this.selectedName= true;
      // this.selectedStateInWorkplace= true;
      // this.selectedZipInWorkplace= true;
      this.showSearchSection = true;
      // this.showSelectedStateZip = true;
      if (!this.showSelectedSearchedResult) {
        this.showDontSeeWorkplaceManually = true;
        this.showAffCodeSection = false;
      } else {
        this.showDontSeeWorkplaceManually = false;
      }
      if (this.searchValue.value) {
        this.searchValue.setValue('');
      }
      this.showStateZipSection = true;
      this.disableSearchPageContinueButton = false;
      const editIconSelected = {
        editOrgDetails: true
      };
      this.editSelected.emit(editIconSelected);
      //   }
    }
  }

  onChangeWorkplace(event?, row?: any) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.disableSearchPageContinueButton = false;
      this.disableAffContinue = true;
      this.affiliatedOrgId = row.orgid;
      this.getOrgProfileDetails();
      // Disable continue button on click of selected value
      // this.disableSearchPageContinueButton = false;
      this.selectedName = row.org_name;
      this.selectedAddress = row.address;
      this.selectedCity = row.city;
      if (row.state !== '' || row.state !== undefined) {
        this.selectedStateInWorkplace = row.state;
      }
      this.selectedZipInWorkplace = row.zipcode;
      this.checkstateAndZip['org_name'] = row.org_name;
      this.checkstateAndZip['address'] = row.address;
      this.checkstateAndZip['city'] = row.city;
      if (row.state !== '' || row.state !== undefined) {
        this.checkstateAndZip['state'] = row.state;
      }
      this.checkstateAndZip['zipcode'] = row.zipcode;
      // Hide the search result and display the selected one
      this.displaySearchResult = false;
      this.showAffCodeSection = false;
      // Show the selected organization details
      this.showSelectedSearchedResult = true;
      this.showDontSeeWorkplaceManually = false;
      this.showAffCodeSection = false;
      this.affiliationCodeList = [];
    }
  }

  onChangeAffCode(event) {
    this.checkAffCode = '';
    if (event.value === 'Select') {
      this.disableAffContinue = true;
      this.disableSearchPageContinueButton = true;
    }
    else {
      this.affiliationCodeValueOption = event;
      this.affiliationCode = event?.value;
      if (this.affiliationCode && this.affiliationCode !== 'Select') {
        this.disableSearchPageContinueButton = false;
        this.disableAffContinue = false;
        this.hideButtons = true;
      }
    }
  }

  noAffCodeSelected(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.affiliationCode = '';
      this.hideButtons = false;
      this.disableSearchPageContinueButton = false;
      // RapidSOS org selection must survive skipping the searched org's affiliation code.
      const storedOrgInfo = sessionStorage.getItem('orgInfo');
      if (storedOrgInfo && !JSON.parse(storedOrgInfo)['isRapidSOS']) {
        sessionStorage.removeItem('orgInfo');
      }
    }
  }

  setOrgDetails(data) {
    this.isSpaOrg = false;
    if (data && data.profile) {
      data.profile.forEach(val => {
        if (val.attribute_name === 'isSpaOrg' && val.attribute_value === 'TRUE') {
          this.isSpaOrg = true;
        }
      });
    }
    this.OrgDetails = {
      orgProfileInfo: data,
      orgid: data.orgid,
      orgName: data.orgName,
      isSpaOrg: this.isSpaOrg,
      affiliationCode: this.affiliationCode
    };
    sessionStorage.setItem('orgInfo', JSON.stringify(this.OrgDetails));
    this.setLoading(false);
  }

  goToGoodNewsPage(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (this.affiliationCode && this.affiliationCode !== 'Select') {
        this.setLoading(true);
        const param = { retcode: this.affiliationCode };
        const url = `${this.urlUtil.formatURlParams(CFETILMEndpointsConstant.GET_AFFILIATION_CODE, param)}`;
        // orgInfo must be saved before leaving, or the info page falls back to the no-code org search.
        this.cfetService.cfetLiveGet('', url).subscribe((data: any) => {
          this.setOrgDetails(data);
          this.completeWorkplaceSelection();
        }, (_error) => {
          this.setLoading(false);
          console.log('Error fetching affiliation code details:', _error);
        });
        return;
      }
      this.completeWorkplaceSelection();
    }
  }

  private completeWorkplaceSelection() {
    this.showSearchSection = false;
    this.showSelectedStateZip = false;
    this.displaySearchResult = false;
    this.showVerifySection = false;
    this.showEligibilityCompletion = true;
    const workPlaceInfo = {
      completionStatus: true,
      selectedName: this.selectedName,
      selectedAddress: this.selectedAddress,
      selectedCity: this.selectedCity,
      selectedStateInWorkplace: this.selectedStateInWorkplace,
      selectedZipInWorkplace: this.selectedZipInWorkplace
    };
    this.eligibilitycompletionstatus.emit(workPlaceInfo);
    console.log("SEARCH FLOW → agencyName set:", this.selectedName);
    this.workplaceSelected.emit(true);
    this.stateAndZipPresent.emit(this.checkstateAndZip);
    this.manuallyEnteredValues = {};
    if (this.showSelectedSearchedResult && !this.showDontSeeWorkplaceManually) {
      sessionStorage.setItem('agencyNameSource', 'userSearchResult');
    }
  }

  getOraInformation(json: any): { ora_required: string; ora_required_attributes: string[] } {
    const oraRequiredAttribute = json.profile.find(attr => attr.attribute_name === 'ora_required');
    const oraRequiredAttributes = json.profile.find(attr => attr.attribute_name === 'ora_required_attributes');
    if (!oraRequiredAttribute || !oraRequiredAttributes) {
      return {
        ora_required: 'N',
        ora_required_attributes: []
      };
    }
    if (oraRequiredAttribute.attribute_value === 'Y') {
      return {
        ora_required: 'Y',
        ora_required_attributes: oraRequiredAttributes.attribute_mvalue
      };
    } else {
      return {
        ora_required: 'N',
        ora_required_attributes: []
      };
    }
  }

  editWorkplaceOnManualEntry(event) {
    if (event !== undefined) {
      //this.showSelectedStateZip = event;
      //this.showSearchSection = event;
      this.searchValue.setValue('');
      this.showDontSeeWorkplaceManually = false;
      this.goToQAndA.emit(true);
    }
  }

  signupDone(event) {
    if (event !== undefined && event) {
      let isSpaTerriroryState = this.territoryStates.includes(this.selectedStateInWorkplace);

      const signupDoneStatus = {
        signupDoneStatus: event,
        completionStatus: true,
        selectedName: this.selectedName,
        selectedAddress: this.selectedAddress,
        selectedCity: this.selectedCity,
        selectedStateInWorkplace: this.selectedStateInWorkplace,
        selectedZipInWorkplace: this.selectedZipInWorkplace,
        searchResults: this.searchResultsFullData,
        isSpaTerriroryState: isSpaTerriroryState
      };
      this.showVerifySection = true;
      this.eligibilitycompletionstatus.emit(signupDoneStatus);
    } else if (!event) {
      if (!this.nonSpaAffCode) {
        this.showEligibilityCompletion = false;
        this.showStateZipSection = false;
        this.showSelectedStateZip = false;
        this.showSearchSection = false;
        this.showDontSeeWorkplaceManually = false;
        const editIconSelected = {
          editJobDetails: true
        };
        this.editSelected.emit(editIconSelected);
      } else {
        this.showEligibilityCompletion = false;
        this.showSearchSection = true;
        if (!this.showSelectedSearchedResult) {
          this.showDontSeeWorkplaceManually = true;
          this.showAffCodeSection = false;
        } else {
          this.showDontSeeWorkplaceManually = false;
        }
        if (this.searchValue.value) {
          this.searchValue.setValue('');
        }
        this.showStateZipSection = true;
        const editIconSelected = {
          editIconSelected: true
        };
        this.editSelected.emit(editIconSelected);
      }
    }
  }

  manualCompleteStatus(event) {
    this.showWorkplaceSection = false;
    const eligibilityStatus = event;
    const eligibilityInfo = {
      eligibilityStatus: eligibilityStatus,
      manualEntry: true
    };
    this.eligibilitycompletionstatus.emit(eligibilityInfo);
    this.disableSearchPageContinueButton = false;
    this.router.navigate([CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF,'completion'])
  }

  manualValues(event) {
    this.manuallyAddedValues.emit(event);
  }

  saveManualValues(event) {
    if (event !== undefined && event.org_name && event.org_name !== '') {
      this.savedManualValues.emit(event);
    }
  }

  displayCancelModal(event) {
    if (event) {
      this.showCancelModal.emit(true);
    }
  }

  redirectUrl(url) {
    window.location.href = url;
  }

  goBackToQAndA(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.goToQAndA.emit(true);
    }
  }

}
